import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';

/** One bus in the live feed (the same payload the passenger app receives). */
export interface LiveBus {
  _id: string;
  arvento_id?: string;
  name?: string;
  number?: string;
  color: string;
  heading?: number;
  is_active: boolean;
  is_visible: boolean;
  geometry?: { type: 'Point'; coordinates: [number, number] };
  line?: { _id?: string; name: string } | null;
}

/** Live bus positions, pushed every 3 seconds over Socket.IO. */
export function useLiveBuses() {
  const [buses, setBuses] = useState<LiveBus[]>([]);
  const [updatedAt, setUpdatedAt] = useState<Date | null>(null);
  const [connected, setConnected] = useState(false);
  useEffect(() => {
    const socket = io({ path: '/ws/socket.io', transports: ['websocket', 'polling'] });
    socket.on('connect', () => setConnected(true));
    socket.on('disconnect', () => setConnected(false));
    socket.on('bus_update', (data: LiveBus[]) => {
      setBuses(data);
      setUpdatedAt(new Date());
    });
    return () => {
      socket.close();
    };
  }, []);
  return { buses, updatedAt, connected };
}
